// Mobile drawer
(function(){
  var ov  = document.getElementById('kfOv');
  var drw = document.getElementById('kfDrawer');
  var op  = document.getElementById('kfMenuOpen');
  var cl  = document.getElementById('kfMenuClose');
  if(!ov || !drw) return;
  function open(){ drw.classList.add('on'); ov.classList.add('on'); document.body.style.overflow='hidden'; }
  function close(){ drw.classList.remove('on'); ov.classList.remove('on'); document.body.style.overflow=''; }
  if(op) op.addEventListener('click', open);
  if(cl) cl.addEventListener('click', close);
  ov.addEventListener('click', close);
  drw.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', close); });
})();
